/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { PAGE_TITLE, ROUTE_TYPE } from '../../Configuration'
import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { PascodeMetadata } from '../../assets/ts/data/pascode-metadata'
import { openFile } from '../../assets/ts/files/files'
import { defaultToEmptyString, twoDigits } from '../../assets/ts/formatting/formatting'
import { DocumentIconNames, generateCodeOptionOnLength, getFilteredItems, getMAJCOMCode, getUniqueCodes } from '../../assets/ts/general/general'
import Buttons from '../../components/buttons/buttons'
import usePageTitle from '../../hooks/use-page-title'
import usePascodeMetadata from '../../hooks/use-pascode-metadata'
import PageHeader from '../../layouts/header/page-header'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { UserContext } from '../../store/user-context-provider'
import { ALL_SELECT_OPTION, ALL_SELECT_VALUE, ALL_SELECT_VALUE_STRING } from '../../utils/constants/global-constants'
import NO_RESULTS from '../../utils/constants/no-results'
import CustomSelect from '../../utils/controls/custom-select'
import { Dropdown, optionsTypes } from '../../utils/controls/select-options-data'

const LIST_NAME = 'PolicyMemoAndGuidelinesList'

interface IntialInputValues {
  assignedComponentCode: number
  majcom: string
  majcomCode: number
}

const PolicyMemosGuidelines = () => {
  usePageTitle(PAGE_TITLE.POLICY_MEMOS_AND_GUIDELINES)
  const navigate = useNavigate()
  const {
    initialInquiryAndDueoutFilter,
    isAssignedComponentOwner,
    isCPOwner,
    isCSS,
    isCustomer,
    isLeadership,
    isMAJCOMOwner,
    isMPFOwner,
    isSectionChief,
    isSectionOwner,
    isSiteAdmin,
    isSupervisor,
    isTechnician,
    userGroups
  } = useContext(RoleContext)

  const userLoginRole = {
    CSSPASCODEFilter: initialInquiryAndDueoutFilter?.cssPASCODES,
    usersAssignedComponentCode: initialInquiryAndDueoutFilter?.assignedComponentCodeFilter,
    usersMajcomCodeFilter: initialInquiryAndDueoutFilter?.majcomCodeFilter,
    usersSectionCodeFilter: initialInquiryAndDueoutFilter?.sectionCodeFilter,
    usersServicingOrganizationFilter: initialInquiryAndDueoutFilter?.servicingOrganizationFilter,
    usersServicingOrganizationWithoutSectionFilter:
      initialInquiryAndDueoutFilter?.servicingOrganizationWithoutSectionFilter,
  }
  const { userProfile } = useContext(UserContext)
  const {
    componentOptions,
    majcomOptions,
    majcoms,
    sections,
  } = useContext(MetadataContext)
  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)
  const { pascodeMetadata } = usePascodeMetadata({
    IsArchived: false,
  })

  const [inputValues, setInputValues] = useState<any>({
    assignedComponentCode: -1,
    majcom: '',
    majcomCode: -1
  })
  const [squadrons, setSquadrons] = useState<any[]>([])
  const [filteredSquadrons, setFilteredSquadrons] = useState<any[]>([])
  const [clearAll, setClearAll] = useState<boolean>(false)
  const [pmgData, setPMGData] = useState<any>({})
  const [accordionsArray, setAccordionsArray] = useState<any[]>([])
  const [majcomDropDown, setMajcomDropdown] = useState<optionsTypes[]>([])
  const [intialComponentDropdown, setIntialComponentDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialMajcomDropdown, setIntialMajcomDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const accordionitems: any = []

  const visibleSquadrons: {
    ACOwner: number[]
    CPOwner: string[]
    Customer: any[]
    Leadership: string[]
    MAJCOMOwner: any[]
    SectionChief: any[]
    SectionOwner: any[]
  } = {
    ACOwner: [],
    CPOwner: [],
    Customer: [],
    Leadership: [],
    MAJCOMOwner: [],
    SectionChief: [],
    SectionOwner: [],
  }

  userGroups.map((group: string) => {
    const splitGroup: string[] = group.split('-')
    if (splitGroup[2] === 'CP Owner') {
      visibleSquadrons.CPOwner.push(splitGroup[0])
    } else if (splitGroup[3] === 'Owner') {
      visibleSquadrons.SectionOwner.push({
        section: splitGroup[2],
        squadron: splitGroup[0],
      })

      
    } else if (splitGroup[2] === 'Leadership') {
      visibleSquadrons.Leadership.push(splitGroup[0])
    } else if (group.includes('Owners')) {
      switch (group) {
        case 'RegAF-Owners':
          visibleSquadrons.ACOwner.push(143)
          break
        case 'AETC-Owners':
          visibleSquadrons.ACOwner.push(144)
          break
        case 'ANG-Owners':
          visibleSquadrons.ACOwner.push(145)
          break
        default:
          break
      }
    } else if (group.includes('MAJCOM')) {
      visibleSquadrons.MAJCOMOwner.push({
        squadron: group.split(' ')[0],
      })
    } else {
      visibleSquadrons.SectionChief.push({
        section: splitGroup[2],
        squadron: splitGroup[0],
      })
    }
  })

  visibleSquadrons.Customer.push({
    squadron: userProfile[0].ServicingOrganization.replace('MPF', 'FSS'),
  })



  const getFiles = async () => {
    const files: any = {}

    const list = await mpfRListsHttp().getList(LIST_NAME)
    const listBlobs: any = await list.blobs().listAll()

    for (const blob of listBlobs) {
      for (const file of blob.blobs) {
        const squadron = file.folderName.split('/')[1]
        const section = file.folderName.split('/')[2]

        if (files[squadron]) {
          if (files[squadron][section]) {
            files[squadron][section].push({
              Id: file.eTag,
              createdBy: file.createdBy,
              eKey: file.eKey,
              fileName: file.fileName,
              folderName: file.folderName,
              itemKey: blob.itemKey,
              metadata: file.metadata,
              modifiedBy: file.modifiedBy,
              modifiedOn: file.modifiedOn,
            })
          } else {
            files[squadron][section] = [
              {
                Id: file.eTag,
                createdBy: file.createdBy,
                eKey: file.eKey,
                fileName: file.fileName,
                folderName: file.folderName,
                itemKey: blob.itemKey,
                metadata: file.metadata,
                modifiedBy: file.modifiedBy,
                modifiedOn: file.modifiedOn,
              },
            ]
          }
        } else {
          files[squadron] = {
            [section]: [
              {
                Id: file.eTag,
                createdBy: file.createdBy,
                eKey: file.eKey,
                fileName: file.fileName,
                folderName: file.folderName,
                itemKey: blob.itemKey,
                metadata: file.metadata,
                modifiedBy: file.modifiedBy,
                modifiedOn: file.modifiedOn,
              },
            ],
          }
        }
      }
    }
    return files
  }

  useEffect(() => {
    if (pascodeMetadata.length > 0) {
      const tempSquadrons: any[] = []

      pascodeMetadata.find((pascode) => {
        if (
          pascode?.AssignedComponentCode === inputValues.assignedComponentCode &&
          (pascode?.ServicingMAJCOM === inputValues.majcom || inputValues.majcom === '')
        ){
          tempSquadrons.push({
            assignedComponent: pascode?.AssignedComponentCode,
            majcom: pascode?.ServicingMAJCOM,
            title: pascode?.ServicingOrganization,
          })
        }
      })
      const squadData = [
        ...Object.values(
          tempSquadrons.reduce(
            (acc, obj) => ({
              ...acc,
              [obj.title]: obj,
            }),
            {}
          )
        ),
      ]
      setSquadrons(squadData)
      setFilteredSquadrons(squadData)
    }
  }, [pascodeMetadata, inputValues])

  useEffect(() => {
    const pmgFiles: any = {
      'Career Development': {fileName: 'Career Development', files: []},
      'Customer Support': {fileName: 'Customer Support', files: []},
      'Force Management': {fileName: 'Force Management', files: []},
      'Installation Personnel Readiness': {fileName: 'Personnel Systems Management', files: []},
      'Personnel Systems Management': {fileName: 'Personnel Systems Management', files: []}
    }

    if (sections?.length > 0) {
      getFiles().then((files) => {
        if (filteredSquadrons.length > 0) {
          filteredSquadrons.forEach((squadron: any) => {
            let containsSquadron = false
            Object.keys(visibleSquadrons).forEach((key) => {
              if (visibleSquadrons[key].length > 0) {
                const formattedSquadron: string = !isNaN(squadron?.title?.split(' ')[0])
                  ? squadron.title.replace('MPF', 'FSS')
                  : squadron.title
  
                if (
                  visibleSquadrons[key].includes(formattedSquadron) ||
                  visibleSquadrons[key].some((e) => e.squadron === formattedSquadron || 
                  e.squadron === squadron?.majcom) ||
                  visibleSquadrons.ACOwner.includes(squadron?.assignedComponent)
                ) {
                  containsSquadron = true
                }
              }
  
              if (containsSquadron || isMPFOwner || isCPOwner || 
                isAssignedComponentOwner) {
                sections.forEach((section: any) => {
                  // gets files based on the squadron/section
                  const sectionFiles = files[squadron.title]
                    ? files[squadron.title][section.Section]
                      ? files[squadron.title][section.Section].sort((a, b) =>
                          b.modifiedOn.localeCompare(a.modifiedOn)
                        )
                      : []
                    : []
  
                  if (pmgFiles[section.Section]) {
                    pmgFiles[section.Section].files.push(...sectionFiles)
                  } else {
                    pmgFiles[section.Section] = {
                      fileName: section.Section,
                      files: sectionFiles,
                    }
                  }
                })
              }
            })
  
            Object.keys(pmgFiles).forEach((key) => {
              pmgFiles[key].files = [
                ...Object.values(
                  pmgFiles[key].files.reduce(
                    (acc, obj) => ({
                      ...acc,
                      [obj.Id]: obj,
                    }),
                    {}
                  )
                ),
              ]
  
              pmgFiles[key].files.forEach((file, index) => {
                let attachmentIcon = ''
  
                switch (file.fileName.split('.')[file.fileName.split('.').length - 1]) {
                  case 'docx':
                    attachmentIcon = 'icon-worddoc'
                    break
                  case 'ppt':
                    attachmentIcon = 'icon-pptdoc'
                    break
                  case 'pdf':
                    attachmentIcon = 'icon-pdf'
                    break
                  case 'xlsx':
                  case 'csv':
                    attachmentIcon = 'icon-excel'
                    break
                }
  
                pmgFiles[key].files[index].AttachmentIcon = attachmentIcon
              })
            })
            setPMGData(pmgFiles)
          })
        } else setPMGData(pmgFiles)
        
      })
    }
  }, [sections, filteredSquadrons])

  const redirectToHome = () => {
    navigate(`${ROUTE_TYPE}`)
  }
  const onAssignComponentChange = (e: { label: string; value: number }) => {
    const tempSquadrons = squadrons.filter(
      (squadron) => squadron.assignedComponent === e.value || e.value === -1
    )
    setFilteredSquadrons(tempSquadrons)

    const option: Dropdown[] = majcoms
      .filter(({ ParentComponentCode }) => ParentComponentCode === e.value)
      .map(({ Label, Value }) => ({ label: Label, value: Value }))
    const intialmajcomCodes = intialMajcomDropdown.map(({ value }) => value)
    const options = option.filter(({ value }) => intialmajcomCodes.includes(value as number))
    if (options.length > 1) options.unshift(ALL_SELECT_OPTION)
    setMajcomDropdown(options as optionsTypes[])
    setInputValues((prev) => ({
      ...prev,
      assignedComponentCode: e.value,
      majcom: options.length === 1 ? options[0].label : '',
      majcomCode: options.length === 1 ? options[0].value : -1,
    }))
  }

  const onMAJCOMChange = (e: any) => {
    const tempSquadrons = squadrons.filter(
      (squadron) =>
        (squadron.assignedComponent === inputValues.assignedComponentCode ||
          inputValues.assignedComponentCode === -1) &&
        (e.label === '' || squadron.majcom === e.label)
    )

    setFilteredSquadrons(tempSquadrons)

    setInputValues({
      ...inputValues,
      majcom: e.label,
      majcomCode: e.value
    })
  }

  const setintialOptions = (
    componentOptions: optionsTypes[],
    ownerIntialMajcom?: optionsTypes[],
  ) => {
    const componentValue = userProfile[0].AssignedComponentCode
    const servicingMAJCOM = userProfile[0].ServicingMAJCOM
    const servicingMAJCOMCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
    setIntialComponentDropdown(componentOptions)
    setIntialMajcomDropdown(majcomOptions)
    setMajcomDropdown(ownerIntialMajcom ? ownerIntialMajcom : majcomOptions)
    const dropdownValues = {
      assignedComponentCode: componentValue,
      majcom: servicingMAJCOM,
      majcomCode: servicingMAJCOMCode
    }
    if (!location.state?.filterValues) {
      setInputValues((prev) => ({
        ...prev,
        ...dropdownValues,
      }))
    }
  }

  function dataArray() {
    Object.keys(pmgData)?.map((policymemoList: any) => {
      accordionitems.push({
        content: (
          <ul className='list-type-none px-2 d-flex row'>
            {folderFileItems(pmgData[policymemoList].files)}
          </ul>
        ),
        count: twoDigits(pmgData[policymemoList].files.length),
        title: policymemoList,
      })
    })
    accordionitems?.sort((a: any, b: any) => a?.title?.localeCompare(b?.title))
    setAccordionsArray(accordionitems)
  }
  const folderFileItems = (files: any) => {
    return (
      <div className='row'>
        {files && files.length > 0 ? (
          files.map((file: any) => (
            <li className='list-type-arrow col-lg-4 ' key={file.fileName}>
              <div className='links d-flex align-items-center breakall'>
                <span className={`me-1 ${DocumentIconNames(file.fileName)}`}></span>
                <a
                  className='links poppins-medium font-13 links-over-underline links'
                  onClick={() => {
                    openFile(file, file.itemKey.split('__')[1], LIST_NAME)
                  }}
                  title={file.fileName}
                >
                  {defaultToEmptyString(file.fileName)}
                </a>
              </div>
            </li>
          ))
        ) : (
          <div className='min-h-100 d-flex align-items-center justify-content-around'>
            <NO_RESULTS />
          </div>
        )}
      </div>
    )
  }
  useEffect(() => {
    dataArray()
  }, [pmgData])

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes

  useEffect(() => {
    const assignedComponentOptions = componentOptions.filter(
      ({ value }) => value !== ALL_SELECT_VALUE
    )
    if (isCPOwner || isSiteAdmin) {
      const profileComponentCode = userProfile[0].AssignedComponentCode
      const majcomCodes = majcoms
        .filter((item) => item.ParentComponentCode === profileComponentCode)
        .map((item) => item.MAJCOMCode)
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      setintialOptions(
        assignedComponentOptions,
        majcomOption,
      )
    } else if (isAssignedComponentOwner) {
      const componentCodes = userLoginRole?.usersAssignedComponentCode
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomCodes = majcoms
        .filter((item) => componentCodes?.includes(item.ParentComponentCode))
        .map((item) => item.MAJCOMCode)
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption
      )
    } else if (isMAJCOMOwner) {
      const majcomCode = userLoginRole?.usersMajcomCodeFilter
      const profileMajcomCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
      const majcomCodes = majcomCode.includes(profileMajcomCode)
        ? majcomCode
        : (majcomCode.unshift(profileMajcomCode), majcomCode)

      const componentCodes = majcoms
        .filter((item) => majcomCodes?.includes(item.MAJCOMCode))
        .map((item) => item.ParentComponentCode)
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption
      )
    } else if (isLeadership || isMPFOwner) {
      const roleOrganizations =
        userLoginRole?.usersServicingOrganizationWithoutSectionFilter as string[]
      const profileOrganization = userProfile[0].ServicingOrganization
      const organizations = roleOrganizations.includes(profileOrganization)
        ? roleOrganizations
        : (roleOrganizations.unshift(profileOrganization), roleOrganizations)
      const filteredItems: PascodeMetadata[] = getFilteredItems(pascodeMetadata, organizations)
      const { componentCodes, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption
      )
    } else if (isCSS) {
      const userCSSPASCODES = userLoginRole?.CSSPASCODEFilter
      const userProfilePASCODE = userProfile[0].PASCODE
      const cssPASCODES = userCSSPASCODES.includes(userProfilePASCODE)
        ? userCSSPASCODES
        : (userCSSPASCODES.unshift(userProfilePASCODE), userCSSPASCODES)
      const filteredItems = pascodeMetadata.filter((item) => cssPASCODES?.includes(item.PASCODE))
      const { componentCodes, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption
      )
    } else if (isSupervisor || isTechnician || isSectionChief || isSectionOwner) {
      const roleOrganizations = userLoginRole?.usersServicingOrganizationFilter as string[]
      const profileOrganization = userProfile[0].ServicingOrganization
      const organizations = roleOrganizations.includes(profileOrganization)
        ? roleOrganizations
        : (roleOrganizations.unshift(profileOrganization), roleOrganizations)
      const filteredItems = getFilteredItems(pascodeMetadata, organizations)
      const { componentCodes, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption
      )
    } else {
      const componentCode = [userProfile[0].AssignedComponentCode]
      const servicingMAJCOMCode = [getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)]
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCode
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, servicingMAJCOMCode)

      setintialOptions(assignedComponentCodeOptions, majcomOption, )
    }
  }, [
    isSiteAdmin,
    isCSS,
    isCPOwner,
    isAssignedComponentOwner,
    isMAJCOMOwner,
    pascodeMetadata,
    isCustomer,
    clearAll
  ])

  return (
    <>
      <PageHeader
        extras={
          <div className='d-flex flex-wrap align-items-center'>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-200 min-w-sm-200  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='AssignedComponent'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Assigned Component'
                name='Assigned Component'
                onChange={onAssignComponentChange}
                options={intialComponentDropdown}
                value={inputValues?.assignedComponentCode}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='ServicingMAJCOM'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={onMAJCOMChange}
                options={majcomDropDown}
                value={inputValues?.majcomCode}
              />
            </div>
            <div className='ms-2 mb-1 ms-auto'>
              <Buttons
                className='btn btn-sm links ms-auto ms-sm-0 ms-md-0 p-0 links-underline'
                label='Clear All'
                onClick={() => setClearAll(!clearAll)}
                type='button'
              />
            </div>
            <div className='mx-2 mb-1 d-none'>
              <Buttons
                aria-label='Back'
                className='btn-sm font-14 btn-bgcolor7 whitetext  border-radius text-uppercase'
                icon='icon-left-arrow me-1 font-10'
                label='Back'
                onClick={(e: any) => redirectToHome()}
              />
            </div>
          </div>
        }
        icon='icon-pmg font-14 me-1 color-primary'
        name=' Policy Memos & Guidelines'
      />
      <div className='container'>
        <div className='card shadow mt-3'>
          <div className='card-body'>
            <div className='row'>
              {accordionsArray?.map((folderItems: any) => (
                <div className='' key={folderItems.title}>
                  <div className='mx-3 my-0 h-100 '>
                    <div className='m-0 bgcolor-65 p-2'>
                      <h2 className='poppins-semibold font-13 title-color53'>
                        {defaultToEmptyString(folderItems.title)} (
                        {defaultToEmptyString(folderItems.count)})
                      </h2>
                    </div>
                    <div>{folderItems.content}</div>
                  </div>
                </div>
              ))}
              {/* {
                    accordionsArray.length === 0 && filesArray.length === 0 && <div className='min-h-200 d-flex align-items-center justify-content-around'>
                      <Noresult />
                    </div>
                  } */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default PolicyMemosGuidelines
